import React from "react";
import {SkeletonWrapper} from "../../dashboard/stats/SkeletonWrapper";
import Skeleton from "react-loading-skeleton";

export const AdditionsSkeleton = () => {

    const renderAdditions = () => {
        return Array.from({length: 4}).map((_, index) => (
            <Skeleton key={index} height={35}/>
        ));
    }

    const renderLetterGroups = () => {
        return Array.from({length: 4}).map((_, index) => (
            <div className={'letter-group-container'} key={index}>
                <div className={'letter-group-content'} style={{marginTop: '55px'}}>
                    {renderAdditions()}
                </div>
            </div>
        ))
    }

    return (
        <SkeletonWrapper>
            <div className={'scrollable-wrapper'}>
                <div className={'scroll-container'}>
                    {renderLetterGroups()}
                </div>
            </div>
        </SkeletonWrapper>
    );
}